// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PlpAccountRegisterRegisterResponse {
    static getAttributeTypeMap() {
        return PlpAccountRegisterRegisterResponse.attributeTypeMap;
    }
}
PlpAccountRegisterRegisterResponse.discriminator = undefined;
PlpAccountRegisterRegisterResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Extauth2ValidateStatus"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=plpAccountRegisterRegisterResponse.js.map